import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class CellsGroup extends PureComponent {
  render() {
    const { children, className, form, ...others } = this.props;
    const cls = classNames({
      "weui-cells__group": true,
      "weui-cells__group_form": form
    }, className);

    return <div className={ cls } { ...others }>
      { children }
    </div>;
  }
}
